import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

const MetaViewport = (props) => {
	if (props.viewport) {
		const value = props.viewport

		return (
			<Helmet>
				<meta name="viewport" content={value} />
			</Helmet>
		)
	}

	return null
}

MetaViewport.propTypes = {
	viewport: PropTypes.string,
}

export default MetaViewport



// WEBPACK FOOTER //
// ./src/common/components/meta/meta-viewport.js